import { render, staticRenderFns } from "./GuochanDownload.vue?vue&type=template&id=331dfbae&scoped=true"
import script from "./GuochanDownload.vue?vue&type=script&lang=js"
export * from "./GuochanDownload.vue?vue&type=script&lang=js"
import style0 from "./GuochanDownload.vue?vue&type=style&index=0&id=331dfbae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dfbae",
  null
  
)

export default component.exports